import { useCallback, useEffect } from 'react';
import useSearchComponent from './useSearchComponent';
import { isResultType } from 'global-search-shared';
import { GLOBAL_SEARCH_CUSTOM_EVENT } from '../constants';
const useHandlePreFilteredSearch = () => {
  const {
    loadAndShowSearch
  } = useSearchComponent(true);
  const handleOpenPrefilteredSearch = useCallback(event => {
    const filters = event.detail.filters;
    const query = event.detail.query || '';
    if (filters) {
      const validatedFilters = filters.filter(filter => isResultType(filter));
      loadAndShowSearch({
        searchQuery: query,
        searchFilters: validatedFilters.join(),
        searchPreFiltered: 'true'
      });
    }
  }, [loadAndShowSearch]);

  // Listen for the event sent by the GlobalSearchPrefilteredSearchButton
  // component and open search pre-filtered on the filters provided
  useEffect(() => {
    window.addEventListener(GLOBAL_SEARCH_CUSTOM_EVENT, handleOpenPrefilteredSearch);
    return () => {
      window.removeEventListener(GLOBAL_SEARCH_CUSTOM_EVENT, handleOpenPrefilteredSearch);
    };
  }, [handleOpenPrefilteredSearch]);
};
export default useHandlePreFilteredSearch;